import { useQuery } from '@tanstack/react-query';

import { courseConst, ITeacher } from 'modules/courses';
import { $apiV2 } from 'modules/global';

export const getTeacher = (slug?: string) => async () => {
  const { data } = await $apiV2.get(`/teacher/${slug}`);

  return { teacher: data?.data };
};

export const useTeacherBySlug = (slug?: string) => {
  const { data, ...args } = useQuery<{ teacher: ITeacher }>({
    queryKey: [courseConst.queryKeys.TEACHER_BY_SLUG, slug],
    queryFn: getTeacher(slug)
  });

  return { ...data, ...args };
};
